import * as React from 'react';
import { Link } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';

const Header = ({ backButton , title  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("header", {
        className: "express-checkout-header",
        "data-t": "express-checkout-header"
    }, /*#__PURE__*/ React.createElement(Link, {
        className: "express-checkout-header__button",
        url: backButton === null || backButton === void 0 ? void 0 : backButton.href,
        onClick: backButton === null || backButton === void 0 ? void 0 : backButton.onClick
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "chevron-left",
        className: "express-checkout-header__icon",
        width: 24,
        height: 24
    }), /*#__PURE__*/ React.createElement("span", {
        className: "express-checkout-header__button--label"
    }, getLabel('checkout.actions.previousStep'))), /*#__PURE__*/ React.createElement(Heading, {
        variant: "subheading2",
        align: "center",
        component: "h1",
        className: "express-checkout-header__heading"
    }, title));
};

export { Header };
//# sourceMappingURL=Header.js.map
